import useProjectsApi from '../../projects/projectsApi';

export default function useResendInvitationService() {

  const nekstApi = useProjectsApi();

  const resendInvitation = async (personId: number) => {
    await nekstApi.post(`/people/${personId}/invitations`);
  };

  return {
    resendInvitation,
  };
}
